export default "__VITE_ASSET__BqdZcCx$__"